import React from 'react';
import { useAtom } from 'jotai';
import { ButtonField, Icon } from '@wk/components-v3-react16';
import { statusButtonsVisibleAtom } from '../../atoms';

const StatusToggleButton = () => {
  const [isStatusButtonsVisible, setIsStatusButtonsVisible] = useAtom(
    statusButtonsVisibleAtom
  );

  const toggleStatusButtons = () => {
    setIsStatusButtonsVisible(!isStatusButtonsVisible);
  };

  return (
    <ButtonField type={'secondary'}>
      <button
        id="toggle-status-buttons"
        onClick={toggleStatusButtons}
        aria-label={
          isStatusButtonsVisible ? 'Hide status buttons' : 'Show status buttons'
        }
      >
        <span>{isStatusButtonsVisible ? 'Hide Buttons' : 'Show Buttons'}</span>
        {isStatusButtonsVisible ? (
          <Icon name="wk-icon-invisible" />
        ) : (
          <Icon name="wk-icon-visible" />
        )}
      </button>
    </ButtonField>
  );
};

export default StatusToggleButton;
